<template>
  <PropertyOnboardingCard>
    <template #body>
      <View direction="column" gap="lg" class="content">
        <Text variant="h2">Congrats! You are almost set up. Fill your availability</Text>
        <Text variant="body-large" color="secondary">
          This will help Tallo schedule showings that fits seamlessly into your busy life
        </Text>
        <InvestorAvailability />
      </View>
    </template>

    <template #footer>
      <Button variant="ghost" @click="back">
        <Icon name="chevron-left" />
        <span>Back</span>
      </Button>
      <Button @click="goToProperty">Go to your listing</Button>
    </template>
  </PropertyOnboardingCard>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';

import { Button, Icon, Text, View } from '@tallo/design-system';
import { AppRouteNames } from '@tallo/investor/navigation';
import { usePropertyStore } from '@tallo/investor/property';

import InvestorAvailability from '../../availability/investor-availability.vue';
import { PropertyOnboardingStep } from '../configs/stages.enum';
import { usePropertyOnboardingStore } from '../store/property-onboarding.store';
import PropertyOnboardingCard from './property-onboarding-card.vue';

const router = useRouter();
const propertyOnboardingStore = usePropertyOnboardingStore();
const propertyStore = usePropertyStore();

function back() {
  propertyOnboardingStore.navigateToStep(PropertyOnboardingStep.DESCRIPTION);
}

function goToProperty() {
  router.push({
    name: AppRouteNames.INVESTOR_PROPERTY_DETAILS,
    params: {
      propertyId: propertyStore.property?.id,
    },
  });
}
</script>

<style scoped lang="scss">
.content {
  max-width: 32rem;
  margin: 2.5rem auto;
}
</style>
